import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const expressFeedingListApi = async (data) => {
  const endPoint = `admin/express-feeding/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
